window.showList1 = function () {
  var widget = document.getElementById('list-1');
  if (widget.style.right == '0%') {
    widget.style.right = '-100%';
  } else {
    // track event to fathom
    widget.style.right = '0%';
  }
}
window.showList2 = function() {
  var widget = document.getElementById('list-2');
  if (widget.style.right == '0%') {
    widget.style.right = '-100%';
  } else {
    // track event to fathom
    widget.style.right = '0%';
  }
}